import Header from '../../Components/Header';
import InstitutionsTable from '../../Components/InstitutionsTable';

export const InstitutionList = () => {
	return (
		<div>
			<Header />
			<div className='h-[calc(100vh-100px)] min-h-0'>
				<InstitutionsTable />
			</div>
		</div>
	);
};
